import { parseMcleodDate, formatDateForMcleod } from "../utils/dateHelpers";

export default class CarrierExtraPay {
  static serialize(data) {
    const payload = {
      ...data,
      __type: "driver_extra_pay",
      company_id: "TMS",
      amount: data.amount,
      amount_c: data.currency,
      deduct_code_id: data.deductCodeId,
      short_desc: data.shortDescription,
      descr: data.description,
      payee_id: data.carrierId,
      entered_user_id: data.enteredUserId,
      movement_id: data.movementId,
      order_id: data.orderId,
      units: data.quantity,
      stop_id: data.stopId,
      transaction_date: formatDateForMcleod(data.transactionDate)
    };

    const customProperties = [
      "deductCodeId",
      "shortDescription",
      "description",
      "carrierId",
      "quantity",
      "orderId",
      "currency",
      "enteredUserId",
      "movementId",
      "stopId",
      "transactionDate"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data,
      amount: data.amount,
      deductCodeId: data.deduct_code_id,
      payeeId: data.payee_id,
      shortDescription: data.short_desc,
      description: data.descr,
      carrierId: data.payee_id,
      quantity: data.units,
      stopId: data.stop_id,
      orderId: data.order_id,
      movementId: data.movement_id,
      currency: data.amount_c,
      enteredUserId: data.entered_user_id,
      transactionDate: parseMcleodDate(data.transaction_date)
    };
  }
}